import { render, staticRenderFns } from "./OnlineExam.vue?vue&type=template&id=fc660c10&scoped=true"
import script from "./OnlineExam.vue?vue&type=script&lang=js"
export * from "./OnlineExam.vue?vue&type=script&lang=js"
import style0 from "./OnlineExam.vue?vue&type=style&index=0&id=fc660c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc660c10",
  null
  
)

export default component.exports